import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import Spinner from './Spinner';

const LoadingView = ({ title, message, className, ...props }) => {
  const cn = useClassNames(
    () => ['flex', 'flex-col', 'h-full', 'items-center', 'justify-center', '-mt-8', className],
    [className],
  );
  return (
    <div data-component="LoadingView" className={cn} {...props}>
      <Spinner size="3xl" />
      <h1 className="font-semibold mt-8 leading-none">{title}</h1>
      <p className="m-2 leading-none">{message}</p>
    </div>
  );
};

LoadingView.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default LoadingView;
